export class Constants {
  public static readonly TenantId = 'xiaTenantId'
  public static readonly TenantName = 'xiaTenantName'
}
